import { createSlice } from "@reduxjs/toolkit";

const advtCardSlice = createSlice({
  name: "advtCard",
  initialState: {
    cardType: null,     // "Basic Professional" or "Classic Promotional"
    cardImage: null,    // base64 screenshot
  },
  reducers: {
    setAdvertisingCard(state, action) {
      state.cardType = action.payload.cardType;
      state.cardImage = action.payload.cardImage;
    },
    clearAdvertisingCard(state) {
      state.cardType = null;
      state.cardImage = null;
    }
  }
});

export const { setAdvertisingCard, clearAdvertisingCard } = advtCardSlice.actions;
export default advtCardSlice.reducer;
